"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuadrant = exports.getQuadrantIIJ = exports.cloneIJ = exports.findClosestXY = exports.exists = exports.findClosestTo = exports.isAt = exports.isAtIJ = exports.distanceNormalIIJ = exports.distanceNormalXY = exports.distanceNormal = exports.distanceSquared = exports.isNextToOrAtIJ = exports.isPrettyCloseToIJ = exports.isNextToForBuildingIJ = exports.isNextTo4_IIJ_IJ = exports.isNextToIIJ = exports.halfwayBetweenY = exports.halfwayBetweenX = exports.distanceSimple = exports.distanceSimpleIIJ = exports.distanceSquaredIIJ = exports.cloneIIJ = void 0;
var assert_sidecar_1 = require("./assert-sidecar");
var imports_1 = require("./imports");
var cloneIIJ = function (obj) {
    return {
        i: obj.i,
        j: obj.j,
    };
};
exports.cloneIIJ = cloneIIJ;
var distanceSquaredIIJ = function (a, b) {
    var dx = a.i - b.i;
    var dy = a.j - b.j;
    return dx * dx + dy * dy;
};
exports.distanceSquaredIIJ = distanceSquaredIIJ;
var distanceSimpleIIJ = function (a, b) {
    var dx = a.i - b.i;
    var dy = a.j - b.j;
    return Math.abs(dx) + Math.abs(dy);
};
exports.distanceSimpleIIJ = distanceSimpleIIJ;
var distanceSimple = function (x1, y1, x2, y2) {
    var dx = x1 - x2;
    var dy = y1 - y2;
    return Math.abs(dx) + Math.abs(dy);
};
exports.distanceSimple = distanceSimple;
var halfwayBetweenX = function (a, b) {
    return (a.x + b.x) / 2;
};
exports.halfwayBetweenX = halfwayBetweenX;
var halfwayBetweenY = function (a, b) {
    return (a.y + b.y) / 2;
};
exports.halfwayBetweenY = halfwayBetweenY;
var isNextToIIJ = function (a, b) {
    // if (node.k !== end.k) {
    //   return false
    // }
    var dx = Math.abs(a.i - b.i);
    var dy = Math.abs(a.j - b.j);
    if (dx + dy > 1) {
        return false;
    }
    return true;
};
exports.isNextToIIJ = isNextToIIJ;
var isNextTo4_IIJ_IJ = function (a, bi, bj) {
    var dx = Math.abs(a.i - bi);
    var dy = Math.abs(a.j - bj);
    if (dx + dy > 1) {
        return false;
    }
    return true;
};
exports.isNextTo4_IIJ_IJ = isNextTo4_IIJ_IJ;
var isNextToForBuildingIJ = function (a, b) {
    // if (node.k !== end.k) {
    //   return false
    // }
    var dx = Math.abs(a.i - b.i);
    var dy = Math.abs(a.j - b.j);
    if (dx + dy <= 1) {
        return true;
    }
    if (dx === 0 && dy <= 2) {
        return true;
    }
    return false;
};
exports.isNextToForBuildingIJ = isNextToForBuildingIJ;
var isPrettyCloseToIJ = function (a, b) {
    // if (node.k !== end.k) {
    //   return false
    // }
    var dx = Math.abs(a.i - b.i);
    var dy = Math.abs(a.j - b.j);
    if (dx + dy > 2) {
        return false;
    }
    return true;
};
exports.isPrettyCloseToIJ = isPrettyCloseToIJ;
var isNextToOrAtIJ = function (allowNextTo, a, b) {
    if (allowNextTo) {
        return exports.isNextToIIJ(a, b);
    }
    return exports.isAtIJ(a, b);
};
exports.isNextToOrAtIJ = isNextToOrAtIJ;
var distanceSquared = function (x1, y1, x2, y2) {
    var dx = x1 - x2;
    var dy = y1 - y2;
    return dx * dx + dy * dy;
};
exports.distanceSquared = distanceSquared;
var distanceNormal = function (x1, y1, x2, y2) {
    var dx = x2 - x1;
    var dy = y2 - y1;
    return Math.sqrt(dx * dx + dy * dy);
};
exports.distanceNormal = distanceNormal;
var distanceNormalXY = function (a, b) {
    var dx = b.x - a.x;
    var dy = b.y - a.y;
    return Math.sqrt(dx * dx + dy * dy);
};
exports.distanceNormalXY = distanceNormalXY;
var distanceNormalIIJ = function (a, b) {
    var di = b.i - a.i;
    var dj = b.j - a.j;
    return Math.sqrt(di * di + dj * dj);
};
exports.distanceNormalIIJ = distanceNormalIIJ;
var isAtIJ = function (a, b) {
    return a.i == b.i && a.j === b.j;
};
exports.isAtIJ = isAtIJ;
var isAt = function (x1, y1, x2, y2) {
    return x1 == x2 && y1 === y2;
};
exports.isAt = isAt;
function findClosestTo(objs, i, j, filter, invalid) {
    if (invalid === void 0) { invalid = []; }
    var closestDistance = 10000000;
    var closest = null;
    imports_1.l.forEach(objs, function (c) {
        var d = exports.distanceSquared(i, j, c.i, c.j);
        if (d < closestDistance) {
            if (filter(c)) {
                if (!imports_1.l.includes(invalid, c)) {
                    closestDistance = d;
                    closest = c;
                }
            }
        }
    });
    return closest;
}
exports.findClosestTo = findClosestTo;
function exists(objs, filter, invalid) {
    if (invalid === void 0) { invalid = []; }
    for (var i = 0; i < objs.length; i++) {
        var c = objs[i];
        if (filter(c)) {
            if (!imports_1.l.includes(invalid, c)) {
                return c;
            }
        }
    }
    return null;
}
exports.exists = exists;
function findClosestXY(obj, targets) {
    var closestDistance = 0;
    var closest = null;
    for (var i = 0; i < targets.length; i++) {
        var t = targets[i];
        var d = exports.distanceSquared(obj.x, obj.y, t.x, t.y);
        if (!closest || d < closestDistance) {
            closest = t;
            closestDistance = d;
        }
    }
    assert_sidecar_1.assert.notNil(closest);
    return closest;
}
exports.findClosestXY = findClosestXY;
function cloneIJ(obj) {
    return {
        i: obj.i,
        j: obj.j,
    };
}
exports.cloneIJ = cloneIJ;
function getQuadrantIIJ(start, target) {
    return getQuadrant(start.i, start.j, target.i, target.j);
}
exports.getQuadrantIIJ = getQuadrantIIJ;
function getQuadrant(x1, y1, x2, y2) {
    var dx = x2 - x1;
    var dy = y2 - y1;
    var angle = Math.atan2(dy, dx);
    var degree = angle * (180 / Math.PI);
    var normalizedDegree = (degree + 360) % 360;
    return Math.floor(normalizedDegree / 45);
}
exports.getQuadrant = getQuadrant;
